
    import _Handlebars from 'handlebars/runtime';

    var Handlebars = _Handlebars.default;
    import "/var/catbus/ui/shared/external-tools/jst/_external_tools_menu.handlebars";
import "@canvas/i18n";
import "@canvas/handlebars-helpers/index.js";

    var template = Handlebars.template, templates = Handlebars.templates = Handlebars.templates || {};
    var name = '/var/catbus/ui/features/wiki-page-index/jst/WikiPageIndexItem';
    templates[name] = template(function (Handlebars,depth0,helpers,partials,data) {
  this.compilerInfo = [4,'>= 1.0.0'];
helpers = this.merge(helpers, Handlebars.helpers); partials = this.merge(partials, Handlebars.partials); data = data || {};
  var buffer = "", stack1, helper, options, self=this, functionType="function", escapeExpression=this.escapeExpression, helperMissing=helpers.helperMissing;

function program1(depth0,data) {
  
  var buffer = "", stack1;
  buffer += "\n  <td class=\"not_clickable\" role=\"gridcell\">\n    ";
  stack1 = helpers.unless.call(depth0, (depth0 && depth0.cannot_delete_by_master_course), {hash:{},inverse:self.noop,fn:self.program(2, program2, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n  </td>\n";
  return buffer;
  }
function program2(depth0,data) {
  
  var buffer = "", stack1, helper, options;
  buffer += "\n      <input\n        type=\"checkbox\"\n        class=\"select-page-checkbox\"\n        id=";
  if (helper = helpers.page_id) { stack1 = helper.call(depth0, {hash:{},data:data}); }
  else { helper = (depth0 && depth0.page_id); stack1 = typeof helper === functionType ? helper.call(depth0, {hash:{},data:data}) : helper; }
  buffer += escapeExpression(stack1)
    + "\n        aria-label=\""
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'title': ((depth0 && depth0.title)),
    'i18n_inferred_key': (true),
    'i18n_scope': ("wiki.wiki_page_index_item")
  },data:data},helper ? helper.call(depth0, "select_title_for_deletion_45b08247", "Select %{title} for deletion", options) : helperMissing.call(depth0, "t", "select_title_for_deletion_45b08247", "Select %{title} for deletion", options)))
    + "\"\n        ";
  stack1 = helpers.unless.call(depth0, (depth0 && depth0.deletable), {hash:{},inverse:self.noop,fn:self.program(3, program3, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n        ";
  stack1 = helpers['if'].call(depth0, (depth0 && depth0.isChecked), {hash:{},inverse:self.noop,fn:self.program(5, program5, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n      />\n    ";
  return buffer;
  }
function program3(depth0,data) {
  
  
  return "disabled";
  }

function program5(depth0,data) {
  
  var stack1;
  stack1 = helpers['if'].call(depth0, (depth0 && depth0.deletable), {hash:{},inverse:self.noop,fn:self.program(6, program6, data),data:data});
  if(stack1 || stack1 === 0) { return stack1; }
  else { return ''; }
  }
function program6(depth0,data) {
  
  
  return "checked";
  }

function program8(depth0,data) {
  
  var buffer = "", stack1;
  buffer += " ";
  stack1 = helpers.unless.call(depth0, (depth0 && depth0.published), {hash:{},inverse:self.noop,fn:self.program(9, program9, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "published";
  return buffer;
  }
function program9(depth0,data) {
  
  
  return "un";
  }

function program11(depth0,data) {
  
  
  return "\n      <div><span class=\"front-page\"></span></div>\n    ";
  }

function program13(depth0,data) {
  
  var buffer = "", stack1, helper, options;
  buffer += "\n      <span>"
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'i18n_inferred_key': (true),
    'i18n_scope': ("wiki.wiki_page_index_item")
  },data:data},helper ? helper.call(depth0, "edited_c4fcbdbf", "Edited:", options) : helperMissing.call(depth0, "t", "edited_c4fcbdbf", "Edited:", options)))
    + " "
    + escapeExpression((helper = helpers.tDateToString || (depth0 && depth0.tDateToString),options={hash:{},data:data},helper ? helper.call(depth0, (depth0 && depth0.updated_at), "medium", options) : helperMissing.call(depth0, "tDateToString", (depth0 && depth0.updated_at), "medium", options)))
    + "</span>\n      <span>"
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'i18n_inferred_key': (true),
    'i18n_scope': ("wiki.wiki_page_index_item")
  },data:data},helper ? helper.call(depth0, "by_b90c6b6f", "By", options) : helperMissing.call(depth0, "t", "by_b90c6b6f", "By", options)))
    + " "
    + escapeExpression(((stack1 = ((stack1 = (depth0 && depth0.last_edited_by)),stack1 == null || stack1 === false ? stack1 : stack1.display_name)),typeof stack1 === functionType ? stack1.apply(depth0) : stack1))
    + "</span>\n    ";
  return buffer;
  }

function program15(depth0,data) {
  
  var buffer = "", stack1;
  buffer += "\n      <span>\n        ";
  stack1 = helpers['if'].call(depth0, (depth0 && depth0.todo_date), {hash:{},inverse:self.noop,fn:self.program(16, program16, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n      </span>\n    ";
  return buffer;
  }
function program16(depth0,data) {
  
  var buffer = "", helper, options;
  buffer += "\n          "
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'i18n_inferred_key': (true),
    'i18n_scope': ("wiki.wiki_page_index_item")
  },data:data},helper ? helper.call(depth0, "to_do_date_2cb4bf7b", "To-Do Date:", options) : helperMissing.call(depth0, "t", "to_do_date_2cb4bf7b", "To-Do Date:", options)))
    + " "
    + escapeExpression((helper = helpers.tDateToString || (depth0 && depth0.tDateToString),options={hash:{},data:data},helper ? helper.call(depth0, (depth0 && depth0.todo_date), "date_at_time", options) : helperMissing.call(depth0, "tDateToString", (depth0 && depth0.todo_date), "date_at_time", options)))
    + "\n        ";
  return buffer;
  }

function program18(depth0,data) {
  
  var buffer = "", stack1, helper, options;
  buffer += "\n      <div style=\"display: inline\" role=\"text\">\n      "
    + escapeExpression((helper = helpers.tDateToString || (depth0 && depth0.tDateToString),options={hash:{},data:data},helper ? helper.call(depth0, (depth0 && depth0.updated_at), "medium", options) : helperMissing.call(depth0, "tDateToString", (depth0 && depth0.updated_at), "medium", options)))
    + "\n        <div class=\"hide-overflow\">\n          "
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'i18n_inferred_key': (true),
    'i18n_scope': ("wiki.wiki_page_index_item")
  },data:data},helper ? helper.call(depth0, "by_b90c6b6f", "By", options) : helperMissing.call(depth0, "t", "by_b90c6b6f", "By", options)))
    + " "
    + escapeExpression(((stack1 = ((stack1 = (depth0 && depth0.last_edited_by)),stack1 == null || stack1 === false ? stack1 : stack1.display_name)),typeof stack1 === functionType ? stack1.apply(depth0) : stack1))
    + "\n        </div>\n      </div>\n    ";
  return buffer;
  }

function program20(depth0,data) {
  
  var buffer = "", stack1;
  buffer += "\n  <td role=\"gridcell\">\n    <div class=\"mobile-screenreader-only\">\n      ";
  stack1 = helpers['if'].call(depth0, (depth0 && depth0.todo_date), {hash:{},inverse:self.noop,fn:self.program(21, program21, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n    </div>\n  </td>\n";
  return buffer;
  }
function program21(depth0,data) {
  
  var buffer = "", helper, options;
  buffer += "\n        "
    + escapeExpression((helper = helpers.tDateToString || (depth0 && depth0.tDateToString),options={hash:{},data:data},helper ? helper.call(depth0, (depth0 && depth0.todo_date), "date_at_time", options) : helperMissing.call(depth0, "tDateToString", (depth0 && depth0.todo_date), "date_at_time", options)))
    + "\n      ";
  return buffer;
  }

function program23(depth0,data) {
  
  var buffer = "", stack1, helper, options;
  buffer += "\n  <td role=\"gridcell\" class=\"master-content-lock-cell\"></td>\n  ";
  stack1 = helpers['if'].call(depth0, ((stack1 = (depth0 && depth0.CAN)),stack1 == null || stack1 === false ? stack1 : stack1.PUBLISH), {hash:{},inverse:self.noop,fn:self.program(24, program24, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n  <td role=\"gridcell\">\n    <div class=\"inline-block\">\n      <a id=\"";
  if (helper = helpers.page_id) { stack1 = helper.call(depth0, {hash:{},data:data}); }
  else { helper = (depth0 && depth0.page_id); stack1 = typeof helper === functionType ? helper.call(depth0, {hash:{},data:data}) : helper; }
  buffer += escapeExpression(stack1)
    + "-menu\" aria-label=\""
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'title': ((depth0 && depth0.title)),
    'i18n_inferred_key': (true),
    'i18n_scope': ("wiki.wiki_page_index_item")
  },data:data},helper ? helper.call(depth0, "settings_for_title_d3ca495", "Settings for %{title}", options) : helperMissing.call(depth0, "t", "settings_for_title_d3ca495", "Settings for %{title}", options)))
    + "\" class=\"al-trigger al-trigger-gray\" href=\"#\" role=\"button\" data-popup-within=\"#application\">\n        <i class=\"icon-more\" aria-hidden=\"true\"></i>\n        <span class=\"screenreader-only\">"
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'i18n_scope': ("wiki.wiki_page_index_item")
  },data:data},helper ? helper.call(depth0, "wiki.wiki_page_index_item.menu.settings", "Settings", options) : helperMissing.call(depth0, "t", "wiki.wiki_page_index_item.menu.settings", "Settings", options)))
    + "</span>\n      </a>\n      <ul class=\"al-options\">\n          ";
  stack1 = helpers['if'].call(depth0, ((stack1 = (depth0 && depth0.CAN)),stack1 == null || stack1 === false ? stack1 : stack1.MANAGE), {hash:{},inverse:self.noop,fn:self.program(26, program26, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n          ";
  stack1 = helpers['if'].call(depth0, (depth0 && depth0.DIRECT_SHARE_ENABLED), {hash:{},inverse:self.noop,fn:self.program(44, program44, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n          ";
  stack1 = helpers['if'].call(depth0, ((stack1 = (depth0 && depth0.CAN)),stack1 == null || stack1 === false ? stack1 : stack1.MANAGE), {hash:{},inverse:self.noop,fn:self.program(46, program46, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n      </ul>\n    </div>\n  </td>\n";
  return buffer;
  }
function program24(depth0,data) {
  
  
  return "\n    <td role=\"gridcell\" class=\"publish-cell\"></td>\n  ";
  }

function program26(depth0,data) {
  
  var buffer = "", stack1;
  buffer += "\n              ";
  stack1 = helpers.unless.call(depth0, (depth0 && depth0.cannot_edit_by_master_course), {hash:{},inverse:self.noop,fn:self.program(27, program27, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n              ";
  stack1 = helpers.unless.call(depth0, (depth0 && depth0.cannot_delete_by_master_course), {hash:{},inverse:self.noop,fn:self.program(30, program30, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n              ";
  stack1 = helpers['if'].call(depth0, (depth0 && depth0.front_page), {hash:{},inverse:self.noop,fn:self.program(36, program36, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n              ";
  stack1 = helpers.unless.call(depth0, (depth0 && depth0.front_page), {hash:{},inverse:self.noop,fn:self.program(39, program39, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n              ";
  stack1 = helpers['if'].call(depth0, ((stack1 = (depth0 && depth0.CAN)),stack1 == null || stack1 === false ? stack1 : stack1.DUPLICATE), {hash:{},inverse:self.noop,fn:self.program(42, program42, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n          ";
  return buffer;
  }
function program27(depth0,data) {
  
  var buffer = "", stack1;
  buffer += "\n                  ";
  stack1 = helpers['if'].call(depth0, ((stack1 = (depth0 && depth0.CAN)),stack1 == null || stack1 === false ? stack1 : stack1.UPDATE), {hash:{},inverse:self.noop,fn:self.program(28, program28, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n              ";
  return buffer;
  }
function program28(depth0,data) {
  
  var buffer = "", helper, options;
  buffer += "\n                    <li><a href=\"#\" class=\"icon-edit edit-menu-item\" title=\""
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'i18n_inferred_key': (true),
    'i18n_scope': ("wiki.wiki_page_index_item")
  },data:data},helper ? helper.call(depth0, "edit_c5fbea07", "Edit", options) : helperMissing.call(depth0, "t", "edit_c5fbea07", "Edit", options)))
    + "\">"
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'i18n_inferred_key': (true),
    'i18n_scope': ("wiki.wiki_page_index_item")
  },data:data},helper ? helper.call(depth0, "edit_c5fbea07", "Edit", options) : helperMissing.call(depth0, "t", "edit_c5fbea07", "Edit", options)))
    + "</a></li>\n                  ";
  return buffer;
  }

function program30(depth0,data) {
  
  var buffer = "", stack1;
  buffer += "\n                  ";
  stack1 = helpers['if'].call(depth0, ((stack1 = (depth0 && depth0.CAN)),stack1 == null || stack1 === false ? stack1 : stack1.DELETE), {hash:{},inverse:self.noop,fn:self.program(31, program31, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n              ";
  return buffer;
  }
function program31(depth0,data) {
  
  var buffer = "", stack1, helper, options;
  buffer += "\n                    <li>\n                      <a href=\"#\" class=\"icon-trash delete-menu-item";
  stack1 = helpers.unless.call(depth0, (depth0 && depth0.deletable), {hash:{},inverse:self.noop,fn:self.program(32, program32, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\"\n                         title=\""
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'title': ((depth0 && depth0.title)),
    'i18n_inferred_key': (true),
    'i18n_scope': ("wiki.wiki_page_index_item")
  },data:data},helper ? helper.call(depth0, "delete_title_6c18eba5", "Delete %{title}", options) : helperMissing.call(depth0, "t", "delete_title_6c18eba5", "Delete %{title}", options)))
    + "\" ";
  stack1 = helpers.unless.call(depth0, (depth0 && depth0.deletable), {hash:{},inverse:self.noop,fn:self.program(34, program34, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += ">\n                         "
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'i18n_inferred_key': (true),
    'i18n_scope': ("wiki.wiki_page_index_item")
  },data:data},helper ? helper.call(depth0, "delete_a6efa79d", "Delete", options) : helperMissing.call(depth0, "t", "delete_a6efa79d", "Delete", options)))
    + "\n                      </a>\n                    </li>\n                  ";
  return buffer;
  }
function program32(depth0,data) {
  
  
  return " disabled";
  }

function program34(depth0,data) {
  
  
  return "aria-disabled=\"true\"";
  }

function program36(depth0,data) {
  
  var buffer = "", stack1;
  buffer += "\n                  ";
  stack1 = helpers['if'].call(depth0, ((stack1 = (depth0 && depth0.CAN)),stack1 == null || stack1 === false ? stack1 : stack1.UPDATE), {hash:{},inverse:self.noop,fn:self.program(37, program37, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n              ";
  return buffer;
  }
function program37(depth0,data) {
  
  var buffer = "", stack1, helper, options;
  buffer += "\n                    <li>\n                      <a href=\"#\" class=\"unset-as-front-page-menu-item";
  stack1 = helpers.unless.call(depth0, (depth0 && depth0.published), {hash:{},inverse:self.noop,fn:self.program(32, program32, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\"\n                         title=\""
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'frontPageText': ((depth0 && depth0.frontPageText)),
    'i18n_inferred_key': (true),
    'i18n_scope': ("wiki.wiki_page_index_item")
  },data:data},helper ? helper.call(depth0, "remove_as_frontpagetext_133cdaee", "Remove as %{frontPageText}", options) : helperMissing.call(depth0, "t", "remove_as_frontpagetext_133cdaee", "Remove as %{frontPageText}", options)))
    + "\" ";
  stack1 = helpers.unless.call(depth0, (depth0 && depth0.published), {hash:{},inverse:self.noop,fn:self.program(34, program34, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += ">\n                          <i class=\"icon-remove-bookmark\" aria-hidden=\"true\">"
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'frontPageText': ((depth0 && depth0.frontPageText)),
    'i18n_inferred_key': (true),
    'i18n_scope': ("wiki.wiki_page_index_item")
  },data:data},helper ? helper.call(depth0, "remove_as_frontpagetext_133cdaee", "Remove as %{frontPageText}", options) : helperMissing.call(depth0, "t", "remove_as_frontpagetext_133cdaee", "Remove as %{frontPageText}", options)))
    + "</i>\n                      </a>\n                    </li>\n                  ";
  return buffer;
  }

function program39(depth0,data) {
  
  var buffer = "", stack1;
  buffer += "\n                  ";
  stack1 = helpers['if'].call(depth0, ((stack1 = (depth0 && depth0.CAN)),stack1 == null || stack1 === false ? stack1 : stack1.UPDATE), {hash:{},inverse:self.noop,fn:self.program(40, program40, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n              ";
  return buffer;
  }
function program40(depth0,data) {
  
  var buffer = "", stack1, helper, options;
  buffer += "\n                    <li>\n                      <a href=\"#\" class=\"use-as-front-page-menu-item";
  stack1 = helpers.unless.call(depth0, (depth0 && depth0.published), {hash:{},inverse:self.noop,fn:self.program(32, program32, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\"\n                         title=\""
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'frontPageText': ((depth0 && depth0.frontPageText)),
    'i18n_inferred_key': (true),
    'i18n_scope': ("wiki.wiki_page_index_item")
  },data:data},helper ? helper.call(depth0, "use_as_frontpagetext_fa88bbb2", "Use as %{frontPageText}", options) : helperMissing.call(depth0, "t", "use_as_frontpagetext_fa88bbb2", "Use as %{frontPageText}", options)))
    + "\" ";
  stack1 = helpers.unless.call(depth0, (depth0 && depth0.published), {hash:{},inverse:self.noop,fn:self.program(34, program34, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += ">\n                          <i class=\"icon-bookmark\" aria-hidden=\"true\">"
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'frontPageText': ((depth0 && depth0.frontPageText)),
    'i18n_inferred_key': (true),
    'i18n_scope': ("wiki.wiki_page_index_item")
  },data:data},helper ? helper.call(depth0, "use_as_frontpagetext_fa88bbb2", "Use as %{frontPageText}", options) : helperMissing.call(depth0, "t", "use_as_frontpagetext_fa88bbb2", "Use as %{frontPageText}", options)))
    + "</i>\n                      </a>\n                    </li>\n                  ";
  return buffer;
  }

function program42(depth0,data) {
  
  var buffer = "", helper, options;
  buffer += "\n                  <li>\n                    <a href=\"#\" class=\"icon-copy-course duplicate-wiki-page\" title=\""
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'i18n_inferred_key': (true),
    'i18n_scope': ("wiki.wiki_page_index_item")
  },data:data},helper ? helper.call(depth0, "duplicate_31cec192", "Duplicate", options) : helperMissing.call(depth0, "t", "duplicate_31cec192", "Duplicate", options)))
    + "\">\n                      "
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'i18n_inferred_key': (true),
    'i18n_scope': ("wiki.wiki_page_index_item")
  },data:data},helper ? helper.call(depth0, "duplicate_31cec192", "Duplicate", options) : helperMissing.call(depth0, "t", "duplicate_31cec192", "Duplicate", options)))
    + "\n                    </a>\n                  </li>\n              ";
  return buffer;
  }

function program44(depth0,data) {
  
  var buffer = "", helper, options;
  buffer += "\n              <li>\n                <a\n                  href=\"#\"\n                  class=\"send-wiki-page-to icon-user\"\n                  aria-label=\""
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'i18n_inferred_key': (true),
    'i18n_scope': ("wiki.wiki_page_index_item")
  },data:data},helper ? helper.call(depth0, "send_page_to_another_user_6ef5a7c1", "Send page to another user", options) : helperMissing.call(depth0, "t", "send_page_to_another_user_6ef5a7c1", "Send page to another user", options)))
    + "\"\n                >"
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'i18n_inferred_key': (true),
    'i18n_scope': ("wiki.wiki_page_index_item")
  },data:data},helper ? helper.call(depth0, "send_to_7881bf0e", "Send to...", options) : helperMissing.call(depth0, "t", "send_to_7881bf0e", "Send to...", options)))
    + "</a>\n              </li>\n              <li>\n                <a\n                  href=\"#\"\n                  class=\"copy-wiki-page-to icon-duplicate\"\n                  aria-label=\""
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'i18n_inferred_key': (true),
    'i18n_scope': ("wiki.wiki_page_index_item")
  },data:data},helper ? helper.call(depth0, "copy_page_to_another_course_405cc07c", "Copy page to another course", options) : helperMissing.call(depth0, "t", "copy_page_to_another_course_405cc07c", "Copy page to another course", options)))
    + "\"\n                >"
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'i18n_inferred_key': (true),
    'i18n_scope': ("wiki.wiki_page_index_item")
  },data:data},helper ? helper.call(depth0, "copy_to_a5396a6f", "Copy to...", options) : helperMissing.call(depth0, "t", "copy_to_a5396a6f", "Copy to...", options)))
    + "</a>\n              </li>\n          ";
  return buffer;
  }

function program46(depth0,data) {
  
  var stack1;
  stack1 = self.invokePartial(partials['ui/shared/external-tools/jst/_external_tools_menu.handlebars'], 'ui/shared/external-tools/jst/_external_tools_menu.handlebars', (depth0 && depth0.wiki_page_menu_tools), helpers, partials, data);
  if(stack1 || stack1 === 0) { return stack1; }
  else { return ''; }
  }

  stack1 = helpers['if'].call(depth0, ((stack1 = (depth0 && depth0.CAN)),stack1 == null || stack1 === false ? stack1 : stack1.DELETE), {hash:{},inverse:self.noop,fn:self.program(1, program1, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n<td role=\"gridcell\">\n  <div class=\"hide-overflow\" role=\"text\">\n    <div class=\"wiki-page-title\">\n      <a href=\"";
  if (helper = helpers.html_url) { stack1 = helper.call(depth0, {hash:{},data:data}); }
  else { helper = (depth0 && depth0.html_url); stack1 = typeof helper === functionType ? helper.call(depth0, {hash:{},data:data}) : helper; }
  buffer += escapeExpression(stack1)
    + "\" id=\"wiki_page_index_item_title_";
  if (helper = helpers.page_id) { stack1 = helper.call(depth0, {hash:{},data:data}); }
  else { helper = (depth0 && depth0.page_id); stack1 = typeof helper === functionType ? helper.call(depth0, {hash:{},data:data}) : helper; }
  buffer += escapeExpression(stack1)
    + "\" class=\"wiki-page-link";
  stack1 = helpers['if'].call(depth0, ((stack1 = (depth0 && depth0.CAN)),stack1 == null || stack1 === false ? stack1 : stack1.PUBLISH), {hash:{},inverse:self.noop,fn:self.program(8, program8, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\">";
  if (helper = helpers.title) { stack1 = helper.call(depth0, {hash:{},data:data}); }
  else { helper = (depth0 && depth0.title); stack1 = typeof helper === functionType ? helper.call(depth0, {hash:{},data:data}) : helper; }
  buffer += escapeExpression(stack1)
    + "</a>\n    </div>\n    ";
  stack1 = helpers['if'].call(depth0, (depth0 && depth0.front_page), {hash:{},inverse:self.noop,fn:self.program(11, program11, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n  </div>\n  <div class=\"hide-overflow mobile-column\" aria-hidden=\"true\">\n    <span>"
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'i18n_inferred_key': (true),
    'i18n_scope': ("wiki.wiki_page_index_item")
  },data:data},helper ? helper.call(depth0, "created_6ee36dff", "Created:", options) : helperMissing.call(depth0, "t", "created_6ee36dff", "Created:", options)))
    + " "
    + escapeExpression((helper = helpers.tDateToString || (depth0 && depth0.tDateToString),options={hash:{},data:data},helper ? helper.call(depth0, (depth0 && depth0.created_at), "medium", options) : helperMissing.call(depth0, "tDateToString", (depth0 && depth0.created_at), "medium", options)))
    + "</span>\n    ";
  stack1 = helpers['if'].call(depth0, (depth0 && depth0.last_edited_by), {hash:{},inverse:self.noop,fn:self.program(13, program13, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n    ";
  stack1 = helpers['if'].call(depth0, (depth0 && depth0.collectionHasTodoDate), {hash:{},inverse:self.noop,fn:self.program(15, program15, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n  </div>\n</td>\n<td role=\"gridcell\">\n  <div class=\"mobile-screenreader-only\">\n    "
    + escapeExpression((helper = helpers.tDateToString || (depth0 && depth0.tDateToString),options={hash:{},data:data},helper ? helper.call(depth0, (depth0 && depth0.created_at), "medium", options) : helperMissing.call(depth0, "tDateToString", (depth0 && depth0.created_at), "medium", options)))
    + "\n  </div>\n</td>\n<td role=\"gridcell\">\n  <div class=\"mobile-screenreader-only\">\n    ";
  stack1 = helpers['if'].call(depth0, (depth0 && depth0.last_edited_by), {hash:{},inverse:self.noop,fn:self.program(18, program18, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n  </div>\n</td>\n";
  stack1 = helpers['if'].call(depth0, (depth0 && depth0.collectionHasTodoDate), {hash:{},inverse:self.noop,fn:self.program(20, program20, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n";
  stack1 = helpers['if'].call(depth0, ((stack1 = (depth0 && depth0.CAN)),stack1 == null || stack1 === false ? stack1 : stack1.OPEN_MANAGE_OPTIONS), {hash:{},inverse:self.noop,fn:self.program(23, program23, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n";
  return buffer;
  });
    ;
    ;
    export default templates[name];
  